// src/lib/enterprise-capabilities.ts
// M1 (#571): the closed set of enterprise capabilities + label/description maps and
// the shared frontend types. Adding a capability touches 4 sites (see the plan's
// Constraint 7): the grants-table CHECK constraint, the partner_grant_capability guard,
// the two ARRAY[...] literals in my_enterprise_capabilities, and this const.
export const ENTERPRISE_CAPABILITIES = ['emulate', 'email_monitor', 'analytics_read'] as const;
export type EnterpriseCapability = (typeof ENTERPRISE_CAPABILITIES)[number];

export const CAPABILITY_LABELS: Record<EnterpriseCapability, string> = {
  emulate: 'Emulate members',
  email_monitor: 'Email monitoring',
  analytics_read: 'Analytics',
};

export const CAPABILITY_DESCRIPTIONS: Record<EnterpriseCapability, string> = {
  emulate: 'Log in as a member of this enterprise to help them.',
  email_monitor: 'View cross-workspace campaign and sender-health dashboards.',
  analytics_read: 'View cross-workspace analytics.',
};

export interface EnterpriseCapabilityPartner {
  partner_id: string;
  name: string;
  is_admin: boolean;
  capabilities: EnterpriseCapability[];
}

export interface PartnerMemberCapabilities {
  user_id: string;
  capabilities: EnterpriseCapability[];
  is_admin: boolean;
}
